<template>
  <div class="flex flex-col w-full">

    <div class="grow pointer-events-none" />

    <div class="effect w-full h-12 flex flex-row justify-between pointer-events-auto p-2 ">
      <button v-if='showDownload && hasClip'
                  @click='onDownload'
                  class="pbc-button px-1"
                  :class='myPostedPostsIds.includes(id) ? "pbc-primary-color" : ""'
                  >

        <pbc-icon icon="download-circle-outline" class="mr-1" />
        <span>Download</span>

      </button>

      <pbc-share v-if='showShare'
                 ref='share'
                 @success='shareSuccess'
                 @copied='shareCopy'
                 @error='shareError'
                 :url='shareUrl'
                 :title='post.title'
                 :text='post.title'>
        <template #clickable='{share,busy}'>
          <div v-if='busy' class="mt-4 ml-4 spinner" />
          <button v-else class="h-full px-1 text-center pbc-button" @click='share'>
            <pbc-icon icon="share-variant" :size='18' />
            <p class="ml-1">Share</p>

          </button>
        </template>
      </pbc-share>

      <div class="grow flex flex-row justify-center pointer-events-auto">
        <router-link v-if='showStats' class="pbc-button px-1" :to='playRoute'>
          <pbc-icon icon="comment-multiple-outline" :size='18' />
          <p class="ml-1 mainbar-label">View</p>
        </router-link>

        <client-only>
          <button v-if='showStats && showAdmin' class="main-bar-button" @click='showAdminPopup = true'>
            <p>A</p>
          </button>
        </client-only>
        <client-only>
          <button v-if='showStats && showAdmin' class="main-bar-button" @click='makeTemplate'>
            <p>T</p>
          </button>
        </client-only>
      </div>

      <div>
        <button class="self-end p-1 pbc-button pbc-primary-color" @click='$emit("next")'>
          <!--<plus-circle-outline class="mr-1" />-->
					<pbc-icon icon="plus-circle-outline" />
          Remix
        </button>
      <button v-if='post.replies.total === 0' class="text-xs text-gray-600 flex flex-row items-center" @click='$emit("next")'>
        Be the first to remix
      </button>
      </div>


    </div>
    <div class="effect w-full h-12 flex flex-row justify-center pointer-events-auto p-2 ">

      <button class="text-sm flex flex-row main-bar-button mr-3" @click="doVote(id, 'upvote')">
        <div v-if='voting' class="spinner">&nbsp;</div>
        <pbc-icon icon="heart-outline" v-else-if='!votedData.type' :size='iconSize' />
        <pbc-icon icon="heart" v-else :size='iconSize' />
        <span class="ml-1 text-lg font-bold">{{post.upvotes}}</span>
      </button>

      <!--
      <div v-if='post.replies.total > 0' class="text-gray-300 text-sm flex flex-row items-center">
        <router-link :to='{name:"play",params:{id:post.id}}'>Remixes</router-link>
        <p class="text-lg font-bold ml-2">{{post.replies.total}}</p>
      </div>
      -->

    </div>
    <post-admin v-if='showAdminPopup' @close='showAdminPopup = false' :id='id' />
      <!--
    <pbc-message ref='message' />
      -->
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ClientOnly from 'vue-client-only'
import PbcIcon from '@ui/atoms/PbcIcon.vue';
import PbcMessage from '@ui/molecules/PbcMessage.vue';
import PbcShare from '@ui/atoms/PbcShare.vue';
import gql from 'graphql-tag';

import PostAdmin from '@ui/molecules/PostAdmin.vue';
import Pan from '@icons/Pan.vue';
import PlusCircleOutline from '@icons/PlusCircleOutline.vue';
import FormatText from '@icons/FormatText.vue';
//import ImageFilterBlackWhite from '@icons/ImageFilterBlackWhite.vue';
//import StickerEmoji from '@icons/StickerEmoji.vue';

const uploadTemplateMutation = gql(`
mutation uploadTemplate($id: String!, $title: String!, $thumbnailImage: String!, $labels: String!, $data: String!) {
  uploadTemplate(id: $id, title: $title, thumbnailImage: $thumbnailImage,
                    labels: $labels, data: $data) {
    id
  }
}
`);

export default {
  inject:['api'],
  props: {
    hasClip: {
      type: Boolean,
      default: true
    },
    type:{
      type: String,
      required: true
    },
    id:{
      type:String,
      default:''
    },
    post:{
      type:Object,
      required:true
    },
    showDownload: {
      type:Boolean,
      default:true
    },
    showShare: {
      type:Boolean,
      default:true
    },
    showStats: {
      type:Boolean,
      default:true
    }
  },
  data() {
    const voteMutation = gql(`
      mutation votePost($id: String!, $type: String!) {
        votePost(id: $id, type: $type) {
          id
          upvotes
          downvotes
        }
      }
    `);
    return {
      voteMutation,
      votedData:{},
      showComments: false,
      showAdminPopup: false,
      isSharing: false,
      voting: false
    }
  },
  components: {
		PbcIcon,
    //PlusCircleOutline,
    //PbcMessage,
    PbcShare,
    //ImageFilterBlackWhite,
    //StickerEmoji,
    PostAdmin,
    ClientOnly
  },
  methods: {
    async makeTemplate() {
      const id = window.prompt("id");

      const title = this.post.title;
      const thumbnailImage = 'placeholder.png';
      const labels = '';

      const response = await fetch(this.api.makeGameUrl(this.post.game));

      if (response.status !== 200) {
        throw new Error('cannot load post: ' + (response||{}).status)
      }

      const data = await response.json();
      data.id = id;
      data.template = {
        version:1,
        source:'pbc',
        components:[]
      }
      await this.$apollo.mutate({
        mutation: uploadTemplateMutation,
        variables: {
          id,
          title,
          labels,
          thumbnailImage,
          data:JSON.stringify(data)
        }
      });
    },
    onDownload() {
      this.$emit("click-download");
    },
    onAdd() {
      this.$emit("click-add");
    },
    onText() {
      this.$emit("click-text");
    },
    onStickers() {
      this.$emit("click-stickers");
    },
    onBackground() {
      this.$emit("click-background");
    },
    async doVote(id, type) {
      if (!this.loggedIn) {
        this.$router.push({
          query:{
            loginPrompt:true
          },
        });
        return;
      }

      this.voting = true;
      try {
        const voted = await this.$apollo.mutate({mutation:this.voteMutation, variables: {id, type}});
        this.votedData = {
          type
        }
        return voted;
      } catch (e) {
        throw e;
      } finally {
        this.voting = false;
      }
    },
    shareStart() {
      this.isSharing = true;
    },
    shareSuccess() {
      const id = this.id
      console.log('share success');
      /*
      this.$refs.message.show({
        title:'Link shared.'
      });
      */
      alert('Link shared.');
      this.isSharing = false;
      this.$ana.track({
        eventCategory:'share',
        eventAction:'main-success',
        extra:{
          id
        }
      });
    },
    shareCopy() {
      this.isSharing = false;
      const id = this.id
      /*
      this.$refs.message.show({
        title:'Link copied.'
      });
      */
      alert('Link copied.');
      this.$ana.track({
        eventCategory:'share',
        eventAction:'main-copy',
        extra:{
          id
        }
      });
    },
    shareError(message) {
      const id = this.id
      this.isSharing = false;
      /*
      this.$refs.message.show({
        type: 'error',
        title:'Something went wrong... try again.'
      });
      */
      alert('Something went wrong... try again');
    },
  },
  computed: {
    playRoute() {
      if (this.$route.name === 'new') {
        return {name:"playnew",params:{id:this.post.id}}
      } else {
        return {name:"play",params:{id:this.post.id}}
      }
    },
    showAdmin() {
      return false;
      return process.browser && window.location.hostname === 'localhost';
    },
    iconSize() {
      return 26;
    },
    shareUrl() {
      if (process.browser) {
        return `https://${window.location.hostname}/post/${this.post.id}`;
      } else {
        return `/post/${this.post.id}`
      }
    },
    ...mapState(['myPostedPostsIds', 'loggedIn'])
  },
  watch: {
  }
}
</script>
<style>
.mainbar-label {
}
@media(max-width:321px) {
  .mainbar-label {
    display: none;
  }
}
</style>
